import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Overview from './pages/Overview';
import RLPList from './pages/RLPList';
import RLPDetail from './pages/RLPDetail';
import Messages from './pages/Messages';
import Portfolio from './pages/Portfolio';
import Represented from './pages/Represented';
import Forms from './pages/Forms';
import FormPackageDetail from './pages/FormPackageDetail';
import AgentCosts from './pages/AgentCosts';
import Billing from './pages/Billing';
import Settings from './pages/Settings';
import Auth from './pages/Auth';
import Notifications from './pages/Notifications';
import NotFound from './pages/NotFound';
import { ErrorBoundary } from './components/ErrorBoundary';

export default function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route path="/login" element={<Navigate to="/auth" replace />} />
        <Route path="/signup" element={<Navigate to="/auth" replace />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Overview />} />
          <Route path="/rlps" element={<RLPList />} />
          <Route path="/rlps/:id" element={<RLPDetail />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/represented" element={<Represented />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/forms" element={<Forms />} />
          <Route path="/forms/:id" element={<FormPackageDetail />} />
          <Route path="/outreach/pending" element={<Navigate to="/messages" replace />} />
          <Route path="/outreach" element={<Navigate to="/messages" replace />} />
          <Route path="/agents" element={<Navigate to="/settings/ledger" replace />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/settings/billing" element={<Billing />} />
          <Route path="/settings/ledger" element={<AgentCosts />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </ErrorBoundary>
  );
}
